<template>
  <div class="services-header">
    <div class="tariff-section">
      <i class="icon icon-sc-account-profile"></i>
      <div>
        <h5 class="identity">{{ $props.customerInfo.firstName }}&nbsp;{{$props.customerInfo.lastName}}</h5>
        <p class="sub">{{ $props.customerInfo.title }} - {{$props.customerInfo.description}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'header-customer-data',
  props: {
    customerInfo: {
      type: Object,
      default: () => {
        return { }
      }
    }
  }
}
</script>

<style scoped lang="scss" src="@/assets/styles/components/_services-header.scss"></style>
<style scoped lang="scss">
.services-header {
  .tariff-section {

    i.icon {
      margin-right: 2.4rem;
      font-size: 2.4rem;
    }
  }

  .account-info {
    text-transform: none;
    font-size: 1.6rem;
  }
}
</style>
